import { MediaType, UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';

import { FUTURE_RECORDINGS, RECORDINGS } from 'consts';
import routes from 'routesPaths';

import { getNormalizeMediaType } from './dataNormalizer';
import { modifyPathForDetails } from './modifyPathForDetails';

type ParamsDetails = {
  id: number | string;
  externalId?: string;
  isAggregatedSeriesRecord?: boolean;
  isGroupedSeries?: Boolean;
  isProgramRecord?: boolean;
  mediaTypeParam?: string;
  seriesId?: string;
  subtype?: string;
  isFuture?: boolean;
  isSuppressedEpisode?: boolean;
};

export function resolvePathToDetailsPage({
  id,
  isAggregatedSeriesRecord,
  isGroupedSeries,
  isFuture,
  isProgramRecord,
  seriesId,
  subtype,
  externalId = '',
  mediaTypeParam = '',
  isSuppressedEpisode = false,
}: ParamsDetails) {
  const currentPath = window.location.pathname;
  const { search } = window.location;
  const mediaType = mediaTypeParam && getNormalizeMediaType(mediaTypeParam);
  const isVodSeries = mediaType === MediaType.Series;
  const isNpvr = !!isProgramRecord || (!!subtype && subtype === UIDAPresentationTypeEnum.npvr);
  const isGroupedNpvrOrSuppressedEpisode = isAggregatedSeriesRecord || isSuppressedEpisode;
  const isLeadsToDetailsSeries =
    (subtype && subtype === UIDAPresentationTypeEnum.series_catch_up) ||
    isVodSeries ||
    isGroupedNpvrOrSuppressedEpisode ||
    (!!isGroupedSeries && !!seriesId);

  let path = routes.detailsInfo;

  if (isLeadsToDetailsSeries) {
    path = routes.detailsSeries;
  }

  let resolvedPath = `${window.location.pathname}${path.link(id, mediaTypeParam, externalId)}`;

  if (currentPath === routes.home.path) {
    resolvedPath = `${path.link(id, mediaTypeParam, externalId)}`;
  }

  const modifierPath = path.link(id, mediaTypeParam, externalId);

  resolvedPath = modifyPathForDetails(currentPath, modifierPath) ?? resolvedPath;

  const params = new URLSearchParams(!isNpvr ? search : '');

  if (isNpvr) {
    if (isFuture) {
      // for avoid the bugs with future recording
      params.append('type', FUTURE_RECORDINGS);
    } else {
      params.append('type', RECORDINGS);
    }
  }

  if (isGroupedNpvrOrSuppressedEpisode && !!seriesId) {
    params.append('seriesid', seriesId);
  }

  if (params.toString()) {
    resolvedPath += `?${params.toString()}`;
  }

  return resolvedPath;
}
